import React from 'react';
import ProgramsTemplate from './ProgramsTemplate';
import { GraduationCap } from 'lucide-react';

const EducationTraining = () => {
  const features = [
    {
      title: 'Professional Certification Programs',
      description: 'Comprehensive certification courses for respiratory care professionals at all levels.'
    },
    {
      title: 'Continuing Education',
      description: 'Regular workshops, webinars, and training sessions to keep skills current.'
    },
    {
      title: 'Online Learning Platform',
      description: 'Access to our Virtual University with courses available anytime, anywhere.'
    },
    {
      title: 'Mentorship Programs',
      description: 'Connect with experienced professionals for guidance and career development.'
    },
    {
      title: 'Clinical Training',
      description: 'Hands-on clinical experience in partner healthcare facilities.'
    },
    {
      title: 'International Collaboration',
      description: 'Exchange programs with global respiratory care institutions.'
    }
  ];

  const programs = [
    {
      name: 'Basic Respiratory Care Certificate',
      description: 'Foundational training for healthcare workers entering respiratory care.',
      link: '/university'
    },
    {
      name: 'Advanced Respiratory Therapy',
      description: 'Specialized training in critical care and advanced ventilation techniques.',
      link: '/university'
    },
    {
      name: 'Pediatric Respiratory Care',
      description: 'Specialized course focusing on respiratory care for children and neonates.',
      link: '/university'
    },
    {
      name: 'Leadership Development',
      description: 'Building management and leadership skills for respiratory care professionals.',
      link: '/university'
    }
  ];

  const description = (
    <div>
      <p className="mb-4">
        ARCA's Education & Training program is the cornerstone of our mission to strengthen respiratory care across Africa.
        We provide comprehensive, accessible, and high-quality training programs designed to equip healthcare professionals
        with the knowledge and skills needed to deliver excellent respiratory care.
      </p>
      <p className="mb-4">
        Our programs range from basic certification courses for newcomers to advanced specialized training for experienced
        practitioners. Through our Virtual University, we make world-class education accessible to professionals across the
        continent, breaking down geographical and financial barriers to learning.
      </p>
      <p>
        We partner with leading international respiratory care organizations, universities, and healthcare institutions to
        ensure our curriculum meets global standards while addressing Africa-specific challenges and contexts.
      </p>
    </div>
  );

  return (
    <ProgramsTemplate
      title="Education & Training"
      subtitle="Building capacity through comprehensive respiratory care education"
      description={description}
      icon={GraduationCap}
      features={features}
      programs={programs}
      ctaText="Explore Courses"
      ctaLink="/university"
    />
  );
};

export default EducationTraining;
